import React from 'react';
import { Formik, Field, FieldArray, Form } from 'formik';
import { updateOrderPayload } from '../../../actions'
import { TextField, RaisedButton } from 'material-ui';
import Checkbox from 'material-ui/Checkbox';
import Snackbar from 'material-ui/Snackbar';

const getShippingArr = (shipping, disableView) => shipping.length && shipping.map((val, ind) => ([
  {
    name: `shipping[${ind}].method`,
    label: 'Shipping Method',
    disable: true
  }, {
    name: `shipping[${ind}].name`,
    label: 'Shipping First Name',
    disable: disableView
  }, {
    name: `shipping.${ind}.last_name`,
    label: 'Shipping Last Name',
    disable: disableView
  }, {
    name: `shipping.${ind}.address1`,
    label: 'Address',
    disable: disableView
  }, {
    name: `shipping.${ind}.address2`,
    label: 'Apt/Ste, etc.',
    disable: disableView
  }, {
    name: `shipping.${ind}.city`,
    label: 'City',
    disable: disableView
  }, {
    name: `shipping.${ind}.state`,
    label: 'State',
    disable: disableView
  }, {
    name: `shipping.${ind}.zip`,
    label: 'Zip Code',
    disable: disableView
  },  {
    name: `shipping[${ind}].country`,
    label: 'Shipping Country',
    disable: disableView
  }, ]))

class ShippingAddress extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }
  render() {
    const { styles, disableView, dispatch, order } = this.props
    const shipping = order.shipping
    const shippingArr = getShippingArr(shipping, disableView)
    const hideView = this.props.disableView ? 'none' : 'inline'
    return (
      <div>
        <h2>Shipping Address</h2>
        <div style={{ paddingLeft: '20px', paddingBottom: '20px' }}>
          <Formik
            initialValues={{ shipping }}
            enableReinitialize={true}
            onSubmit={(values) => {
              const new_shipping = [{
                id: values.shipping[0].id,
                method: values.shipping[0].method || '',
                carrier: values.shipping[0].carrier || '',
                name: values.shipping[0].name || '',
                last_name: values.shipping[0].last_name || '',
                address1: values.shipping[0].address1 || '',
                address2: values.shipping[0].address2 || '',
                city: values.shipping[0].city || '',
                state: values.shipping[0].state || '',
                zip: values.shipping[0].zip || '',
                country: values.shipping[0].country || ''
              }]
              dispatch(updateOrderPayload(order.id, 'shipping', new_shipping))
                .then((res) => {
                  this.setState({ open: true })
                })
                .catch((err) => { console.log("ERR", err) })
            }}
            render={(values) => (
              <Form>
                <div style={{ paddingRight: "15px" }} className="list-group">
                  <FieldArray
                    name='shipping'
                    render={arrayHelpers => (
                      <div>
                        {shipping.map((val, index) => (
                          <span style={{ marginBottom: '15px' }} className="list-group-item flex-column align-items-start">
                            <div className="row">
                              {shippingArr[index].map((item, ind) => (
                                <div className="col-md-6 col-lg-4">
                                  <Field name={item.name}>
                                    {({ field }) => (
                                      <div>
                                        <TextField
                                          {...field}
                                          floatingLabelText={item.label}
                                          floatingLabelStyle={styles.floatingLabelStyle}
                                          floatingLabelFixed={true}
                                          disabled={item.disable}
                                        />
                                      </div>
                                    )}
                                  </Field>
                                </div>
                              ))}
                            </div>
                            <br/>
                            <Checkbox
                              label="Business Address"
                              defaultChecked={shipping[index].business || false}
                              name={`shipping[${index}].business`}
                              disabled={true}
                            />
                          </span>
                        ))}
                      </div>
                    )}
                  />
                </div>
                <br /><br />
                {!disableView
                ? <span style={{ display: hideView }}>
                    <RaisedButton type='submit' primary tabIndex={-1}> Save </RaisedButton>
                  </span>
                : null
                }
              </Form>
            )}
          />
        </div>
        <Snackbar
          open={this.state.open}
          message={'Shipping Address Field(s) Edited Successfully!'}
          autoHideDuration={4000}
        />
      </div>
    )
  }
}

export default ShippingAddress;


// WEBPACK FOOTER //
// ./src/components/orders/Common/ShippingAddress.js